import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function BoundaryLinkSection() {
  return (
    <section className="container py-10">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
        <div className="paper-card p-6 lg:col-span-8">
          <p className="eyebrow">Scope & boundaries</p>
          <h2 className="mt-3 font-display text-2xl font-medium text-foreground">
            Readiness mapping, evidence gaps and referral triggers.
          </h2>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-muted-foreground">
            NDIS 0138 Readiness identifies operational compliance exposure, documentation risk and referral triggers. It is not legal advice, audit certification, NDIS registration approval or a guaranteed outcome.
          </p>
        </div>
        <div className="paper-card flex flex-col justify-between gap-4 p-6 lg:col-span-4">
          <p className="text-sm leading-relaxed text-muted-foreground">
            Read the public boundary before using the intake or sharing outputs.
          </p>
          <Button asChild variant="outline" className="w-fit rounded-sm">
            <Link to="/what-we-do">
              What We Do / What We Do Not Do
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
